export const bsctest = async ():Promise<bigint> => {
    return BigInt(13n);
}

